import http from './http';

class Data {

    constructor() {
        this.id = null;
        this.data = [];
        this.series = {};
        this.type = 'line';
        this.stacking = false;
        this.loading = true;
        this.times = [];
        this.futureTimes = [];

        this.min = null;
        this.max = null;

        this.aggregates = [];

        this.asHighcharts = {
            chart: {
                renderTo: 'trololo',
            },
        };

        this.colors = ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"];

        this.isColumn = false;

        this.headline = '';


        this.chartTypes = [
            {description: "Line Chart", type: 'line'},
            {description: "Scatter Chart", type: 'scatter'},

            {description: "Area Chart", type: 'area', stacking: null},
            {description: "Stacked Area Chart", type: 'area', stacking: 'normal'},
            {description: "Stacked Area Percent Chart", type: 'area', stacking: 'percent'},

            {description: "Column Chart", type: 'column', stacking: null},
            {description: "Stacked Column Chart", type: 'column', stacking: 'normal'},
            {description: "Stacked Column Percent Chart", type: 'column', stacking: 'percent'},

            {description: "Bar Chart", type: 'bar', stacking: null},
            {description: "Stacked Bar Chart", type: 'bar', stacking: 'normal'},
            {description: "Stacked Bar Percent Chart", type: 'bar', stacking: 'percent'},

        ];

        this.chartType = this.chartTypes[0];
    }

    setChartType(item) {
        this.chartType = item;
        this.type = item.type;
        if (item.stacking !== undefined) {
            this.stacking = item.stacking;
        } else {
            this.stacking = false;
        }

        this.convert();
        this.notify();

    }

    notify() {
        //console.log(this.data.data.chart_type);
        // notify the server about the change. (whatever happened.)
    }

    update(action, ids, parameter = null) {
        const that = this;
        http.post("/panels/" + this.id, {
            _method: 'patch',
            action: action,
            ids: ids,
            parameter: parameter,
        })
            .then(function (response) {
                that.convertSeries(response);
            });
    }

    addSeries(id) {
        const that = this;
        http.post("/panels/" + this.id, {
            _method: 'patch',
            add_series: true,
            id: id,
        })
            .then(function (response) {
                that.convertSeries(response);
            });
    }

    load(id) {
        this.id = id;
        const that = this;
        http.get("/panels/" + id)
            .then(function (response) {
                that.convertSeries(response);
            });
    }

    convertSeries(response) {
        this.data = response.data.data;
        this.aggregates = response.data.aggregates;
        this.headline = response.data.headline;

        this.times = this.convertTimes();
        this.futureTimes = response.data.futureDates;

        let result = this.data;

        this.series = _.cloneDeep(result);

        this.convert();

        this.loading = false;

        this.min = this.computeMin();
        this.max = this.computeMax();

        return result;
    }

    async getDataAync() {

        const x = await http.get("/panels/" + this.id);

        //console.log(x);

        return x.data;
    }

    yAxis() {
        return this.data.map(function (data) {
            return data.unit;
        }).sort().filter(function (item, pos, ary) {
            return !pos || item !== ary[pos - 1];
        }).map(function (axis) {
            /*if (!this.isColumn) {
                return axis;
            }*/

            return axis;
        });
    }

    getVisible() {
        let that = this;
        return this.aggregates
            .concat(this.data)
            .map(function (item, key) {
                item.color = that.colors[key % 10];
                return item;
            })
            .filter(function (item) {
                return item.visible;
            });
    }

    timeSeries() {
        let that = this;
        return this.data.concat(this.aggregates)
            .map(function (item, key) {
                item.color = that.colors[key % 10];
                return item;
            })
            .filter(function (item) {
                return item.visible;
            })
            .map(function (item) {
                const data = item.data.map(function (field) {
                    return [Date.parse(field.time), field.value];
                });

                return {
                    name: item.name,
                    data: data,
                    color: item.color,
                };
            });
    }

    convert() {
        const text = this.headline;

        const yAxis = this.yAxis().map(function (title) {
            return {
                title: {
                    text: title
                }
            };
        });

        let plotOptions = {};

        if (this.type === 'bar' || this.type === 'area') {
            plotOptions = {
                series: {
                    stacking: this.stacking,
                },
            };
        }

        if (this.type === 'column') {
            plotOptions = {
                column: {
                    stacking: this.stacking,
                    dataLabels: {
                        //allowOverlap: true,
                        /*enabled: true,
                        formatter: function() {
                            console.log(this.point.name);
                            return 'foo:' + this.point.name;
                        }*/
                    }
                },
            };
        }


        const json = {
            chart: {
                renderTo: 'trololo',
                type: this.type,
            },
            plotOptions: plotOptions,
            title: {
                text: text,
            },
            series: this.timeSeries(),
            yAxis: yAxis,
            xAxis: {
                type: 'datetime'
            },
            legend: {
                itemStyle: {
                    width: 550,
                },
                enabled: !this.isColumn,
            },
            exporting: {
                buttons: {
                    contextButton: {
                        enabled: false,
                    }
                }
            },
            credits: {
                enabled: false,
                //href: 'https://now.allthatstats.com/', // TODO link to one of the sources! ;-)
                //text: 'Source: ' + this.sources.join(" & "),
            },
        };

        if (this.isColumn) {
            let categories = this.series[0].data.map(function (item) {
                return item[0];
            });

            json.xAxis = {
                categories: categories,
                type: 'category',
                title: {
                    text: null
                },
                labels: {
                    rotation: -45,
                    /*style: {
                        fontSize: '13px',
                        fontFamily: 'Verdana, sans-serif'
                    }*/
                },
                //min: min,
                tickmarkPlacement: 'on',
                //tickInterval: 1,
                //minRange: 1
            };
        }

        this.asHighcharts = json;
    }

    convertTimes() {

        if (this.data === undefined) {
            return [];
        }

        let times = [];
        this.data.forEach(function (series) {
            series.data.forEach(function (item) {
                times.push(item.time);
            })
        });

        times = _.uniq(times).sort().reverse();
        this.active = times[0];
        return times;
    }

    computeMin() {
        let min = null;
        this.data.forEach(function (series) {
            series.data.forEach(function (item) {
                if (item.value === null) {
                    return;
                }
                if (min === null) {
                    min = item.value;
                }
                if (item.value < min) {
                    min = item.value;
                }
            })
        });

        return min;
    }

    computeMax() {
        let max = null;
        this.data.forEach(function (series) {
            series.data.forEach(function (item) {
                if (item.value === null) {
                    return;
                }
                if (max === null) {
                    max = item.value;
                }
                if (item.value > max) {
                    max = item.value;
                }
            })
        });

        return max;
    }


}

export default new Data();